import { Alert } from "antd";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Prompt } from "react-router-dom";
import { haveSameRouteOrder } from "./nearbyRoutes.util";

export const useNearbyRoutesUnsavedWarning = isDirty => {
  useEffect(() => {
    if (!isDirty) return undefined;
    const warnBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", warnBeforeUnload);
    return () => window.removeEventListener("beforeunload", warnBeforeUnload);
  }, [isDirty]);
};

const NearbyRoutesDraftGuard = ({ draftRef, isEnabled }) => {
  const { t } = useTranslation();
  const draft = draftRef.current;
  const isDirty = Boolean(!isEnabled && draft && !haveSameRouteOrder(draft.selectedRouteIds, draft.savedRouteIds));
  useNearbyRoutesUnsavedWarning(isDirty);

  return isDirty ? (
    <>
      <Prompt message={t("NearbyRoutes.UnsavedChanges")} when />
      <Alert message={t("NearbyRoutes.DisabledWithDraft")} type="warning" showIcon />
    </>
  ) : null;
};

NearbyRoutesDraftGuard.propTypes = {
  draftRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
  isEnabled: PropTypes.bool.isRequired,
};

export default NearbyRoutesDraftGuard;
